
(function(){
  if(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  var c=document.getElementById('mp-snow');if(!c)return;
  var ctx=c.getContext('2d'),W,H,flakes=[],dpr=Math.min(window.devicePixelRatio||1,2),raf,t=0;
  function size(){W=innerWidth;H=innerHeight;c.width=W*dpr;c.height=H*dpr;ctx.setTransform(dpr,0,0,dpr,0,0);
    var n=Math.round(Math.min(70,Math.max(25,W*H/22000)));
    while(flakes.length<n)flakes.push(make(true));flakes.length=n;}
  function make(init){var r=Math.random()*1.8+0.8;
    return{x:Math.random()*W,y:init?Math.random()*H:-10,r:r,v:0.25+r*0.22,
      sw:Math.random()*0.6+0.2,ph:Math.random()*6.28,o:0.35+Math.random()*0.35};}
  function draw(){
    ctx.clearRect(0,0,W,H);t+=0.01;
    for(var i=0;i<flakes.length;i++){var f=flakes[i];
      f.y+=f.v;f.x+=Math.sin(t*f.sw*3+f.ph)*0.25;
      if(f.y>H+10||f.x<-10||f.x>W+10){flakes[i]=make(false);flakes[i].x=Math.random()*W;continue;}
      ctx.globalAlpha=f.o;ctx.shadowColor='rgba(120,150,185,0.6)';ctx.shadowBlur=3;
      ctx.fillStyle='#fff';ctx.beginPath();ctx.arc(f.x,f.y,f.r,0,6.283);ctx.fill();}
    raf=requestAnimationFrame(draw);}
  document.addEventListener('visibilitychange',function(){
    if(document.hidden)cancelAnimationFrame(raf);else raf=requestAnimationFrame(draw);});
  addEventListener('resize',size);size();draw();
})();
